// ws-subscriber.ts
type Callback = (data: any) => void;

class WsSubscriber {

  public static getInstance() {
    if (!WsSubscriber.instance) {
      WsSubscriber.instance = new WsSubscriber();
    }
    return WsSubscriber.instance;
  }
  private static instance: WsSubscriber;
  private subscribers: Record<string, Callback[]> = {};

  public subscribe(topic: string, callback: Callback) {
    console.log("catch subscribe:", topic);
    if (!this.subscribers[topic]) { this.subscribers[topic] = []; }
    this.subscribers[topic].push(callback);
  }

  public unsubscribe(topic: string, callback: Callback) {
    if (!this.subscribers[topic]) { return; }
    this.subscribers[topic] = this.subscribers[topic].filter(
      (cb) => cb !== callback,
    );
  }

  public notify(topic: string, payload: any) {
    console.log("notify:", topic, payload);
    const subs = this.subscribers[topic] || [];
    subs.forEach((cb) => cb(payload));
  }
}

// グローバル登録
const wsSub = WsSubscriber.getInstance();
(window as any).subscribe = (topic: string, callback: Callback) =>
  wsSub.subscribe(topic, callback);
(window as any).unsubscribe = (topic: string, callback: Callback) =>
  wsSub.unsubscribe(topic, callback);

// ほかのモジュールやコンポーネントからも直接使えるよう export
export default wsSub;
